export default __webpack_public_path__ + "4fa1f8d8b89a478160c9a5201cbc091f.svg";